// extracted by mini-css-extract-plugin
export default {"button":"a-version-number-module__button a-util-module__button-reset"};